import { forwardRef, type InputHTMLAttributes } from 'react'

interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { label = 'Pesquisar', className = '', ...props },
  ref,
) {
  return (
    <label className={`search-input ${className}`.trim()}>
      <span className="sr-only">{label}</span>
      <span className="search-input__icon" aria-hidden="true">
        ⌕
      </span>
      <input ref={ref} type="search" aria-label={label} {...props} />
    </label>
  )
})
